export const environment = {
    production: true,
    env: 'prod',
    publicPath: 'https://b3way.b3.com.br/auth',
    urlBase: 'https://auth4b3-pf-op.b3.com.br',
    urlBaseGOV: 'https://www.rad.cvm.gov.br/APITokenGovBr/api/GetTokenGovBr',
    redirectUrlDDA: 'https://dda.b3.com.br/DDA.Internet',
    redirectUrlCiCorp: 'https://cicorp.bmfbovespa.com.br/portalPAE',
    redirectUrlENET: 'https://www.rad.cvm.gov.br/ENETWEB/Shared/Login.aspx',
    redirectUrlGOVBR: 'https://www.rad.cvm.gov.br/ENETWEB/frmGovBrB3Way.aspx',
    redirectUrlLogoutGOVBR: 'https://www.rad.cvm.gov.br/ENETWEB/frmLogoutGovBR.aspx',
    redirectUrlPortalCobranca: 'https://atendimento.b3.com.br/facilidades',
    govLogoutUrl: 'https://sso.acesso.gov.br/logout',
    redirectUrlSailPoint: 'https://portaldocau.b3.com.br/identityiq',
    gtmid: 'GTM-NBBGG9DZ',
    redirectUrlIMercado: 'https://imercado.bmfbovespa.com.br/iMercado/',
    redirectUrlNeoWay: 'https://cloud.conteudo.neoway.com.br/lp-smart-target',
    redirectUrlPEAB: 'https://portaldeemissores.b3.com.br',
    urlApiGestaoPermissoes: '',
    urlInstanciaChatbot: 'https://atendimento.b3.com.br',
    urlRedirectChatbot: 'https://b3way.b3.com.br/',
    lastVersion: 'Comunicado novo quadro 6.1/2 - 03/09/2026 - CRQ000000629466'
};
